// Production builds (live and staging) keep the browser console quiet: console.log,
// console.info and console.debug do nothing. Warnings and errors still show.
// Imported first in index.js so it runs before any other module logs.
//
// To see the logs on a live site, run this in the browser console and reload:
//   localStorage.setItem("anna.debugLogs", "1")
// localStorage.removeItem("anna.debugLogs") turns them off again.
const DEBUG_LOGS_KEY = "anna.debugLogs";
const QUIET_METHODS = ["log", "info", "debug"];

function debugLogsWanted() {
  try {
    return window.localStorage.getItem(DEBUG_LOGS_KEY) === "1";
  } catch {
    return false;
  }
}

if (process.env.NODE_ENV === "production" && !debugLogsWanted()) {
  const noop = () => {};
  QUIET_METHODS.forEach((method) => {
    console[method] = noop;
  });
}
